export default {
  SET_VIN(state, value) {
    state.vehicle.VIN = value;
  },
  SET_LOADING(state, value) {
    state.loading = value;
  }
};
